import React, { memo, useEffect, useState } from "react";
import { Image, Flex, Text, Button, Spacer, Box, Divider } from "@chakra-ui/react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import { FaTwitter } from "react-icons/fa";
import { isLogin } from "@/utils/tools";
function PricingComponent() {
   const navigate = useNavigate();
   const id = useSelector((state) => state.user.id, shallowEqual);
   const token = window.localStorage.getItem("token");
   const [bLogin, setBLogin] = useState(false);
   useEffect(() => {
      setBLogin(isLogin(token, id));
   }, [id, token]);
   const { twitter_screen_name } = useSelector(
      (state) => ({
         twitter_screen_name: state.user.twitter_screen_name,
      }),
      shallowEqual
   );
   return (
      <Flex flexDir={"column"} w="1280px" mx={"auto"} alignItems="center">
         <Text variant={"34_black"} mt={"120px"}>
            Pricing
         </Text>
         <Text mt={"20px"} variant="20_gray">
            Boost your NFT sale and build a larger community!
         </Text>
         <Flex flexDir={"row"} mt={"70px"} w={"1280px"} mb={"120px"}>
            <Flex
               as={motion.div}
               whileHover={{ y: "-10px" }}
               mr={"20px"}
               flex={1}
               flexDir={"column"}
               bg={"white"}
               boxShadow={"0px 20px 60px 0px rgba(0,0,0,0.04)"}
               borderRadius={"12px"}>
               <Flex flexDir={"column"} h={"166px"} alignItems={"center"}>
                  <Text variant={"26_black_bold"} mt={"30px"}>
                     Free Trial
                  </Text>
                  <Text variant={"16_gray"} lineHeight={"22px"} mt={"12px"}>
                     The quickest and easiest way
                  </Text>
                  <Text variant={"16_gray"} lineHeight={"22px"}>
                     to try AlohaBots
                  </Text>
               </Flex>
               <Flex px={"24px"} pt={"30px"} pb={"60px"} flexDir={"column"}>
                  <Flex>
                     <Image
                        userSelect="none"
                        w={"14px"}
                        h={"30px"}
                        src={process.env.REACT_APP_PUBLIC_URL + "iconfont/icon_check_selected.svg"}
                     />
                     <Text ml={"15px"} variant={"16_black"} lineHeight={"30px"}>
                        Sales Posted on Twitter: 50
                     </Text>
                  </Flex>
                  <Divider mt={"15px"} />
                  <Flex mt={"14px"}>
                     <Image
                        userSelect="none"
                        w={"14px"}
                        h={"30px"}
                        src={process.env.REACT_APP_PUBLIC_URL + "iconfont/icon_check_selected.svg"}
                     />
                     <Text ml={"15px"} variant={"16_black"} lineHeight={"30px"}>
                        Check for Sales: 30 seconds
                     </Text>
                  </Flex>
                  <Divider mt={"15px"} />
                  <Flex mt={"14px"}>
                     <Image
                        userSelect="none"
                        w={"14px"}
                        h={"30px"}
                        src={process.env.REACT_APP_PUBLIC_URL + "iconfont/icon_check_selected.svg"}
                     />
                     <Text ml={"15px"} variant={"16_black"} lineHeight={"30px"}>
                        Price Data in Multiple Tokens:
                     </Text>
                  </Flex>

                  <Flex lineHeight={"26px"} mt={"2px"} alignItems={"center"} ml={"30px"}>
                     <Box bg="#999" borderRadius={"full"} w={"4px"} h={"4px"} />
                     <Text variant="16_gray" ml={"12px"}>
                        ETH
                     </Text>
                  </Flex>
                  <Flex lineHeight={"26px"} alignItems={"center"} ml={"30px"}>
                     <Box bg="#999" borderRadius={"full"} w={"4px"} h={"4px"} />
                     <Text variant="16_gray" ml={"12px"}>
                        WETH
                     </Text>
                  </Flex>
                  <Flex lineHeight={"26px"} alignItems={"center"} ml={"30px"}>
                     <Box bg="#999" borderRadius={"full"} w={"4px"} h={"4px"} />
                     <Text variant="16_gray" ml={"12px"}>
                        USDC
                     </Text>
                  </Flex>
                  <Flex lineHeight={"26px"} alignItems={"center"} ml={"30px"}>
                     <Box bg="#999" borderRadius={"full"} w={"4px"} h={"4px"} />
                     <Text variant="16_gray" ml={"12px"}>
                        APE
                     </Text>
                  </Flex>
                  <Flex lineHeight={"26px"} alignItems={"center"} ml={"30px"}>
                     <Box bg="white" borderRadius={"full"} w={"4px"} h={"4px"} />
                     <Text variant="16_gray" ml={"12px"}>
                        ...
                     </Text>
                  </Flex>

                  <Divider mt={"15px"} />
                  <Flex mt={"14px"}>
                     <Image
                        userSelect="none"
                        w={"14px"}
                        h={"30px"}
                        src={process.env.REACT_APP_PUBLIC_URL + "iconfont/icon_check_selected.svg"}
                     />
                     <Text ml={"15px"} variant={"16_black"} lineHeight={"30px"}>
                        Most Comprehensive Data Sources:
                     </Text>
                  </Flex>

                  <Flex lineHeight={"26px"} mt={"2px"} alignItems={"center"} ml={"30px"}>
                     <Box bg="#999" borderRadius={"full"} w={"4px"} h={"4px"} />
                     <Text variant="16_gray" ml={"12px"}>
                        Opensea
                     </Text>
                  </Flex>
                  <Flex lineHeight={"26px"} alignItems={"center"} ml={"30px"}>
                     <Box bg="#999" borderRadius={"full"} w={"4px"} h={"4px"} />
                     <Text variant="16_gray" ml={"12px"}>
                        Looksrare
                     </Text>
                  </Flex>
                  <Flex lineHeight={"26px"} alignItems={"center"} ml={"30px"}>
                     <Box bg="#999" borderRadius={"full"} w={"4px"} h={"4px"} />
                     <Text variant="16_gray" ml={"12px"}>
                        X2Y2
                     </Text>
                  </Flex>
                  <Flex lineHeight={"26px"} alignItems={"center"} ml={"30px"}>
                     <Box bg="#999" borderRadius={"full"} w={"4px"} h={"4px"} />
                     <Text variant="16_gray" ml={"12px"}>
                        Gem
                     </Text>
                  </Flex>
                  <Flex lineHeight={"26px"} alignItems={"center"} ml={"30px"}>
                     <Box bg="#999" borderRadius={"full"} w={"4px"} h={"4px"} />
                     <Text variant="16_gray" ml={"12px"}>
                        Genie
                     </Text>
                  </Flex>

                  <Divider mt={"15px"} />

                  <Flex mt={"14px"}>
                     <Image
                        userSelect="none"
                        w={"14px"}
                        h={"30px"}
                        src={process.env.REACT_APP_PUBLIC_URL + "iconfont/icon_check_selected.svg"}
                     />
                     <Text ml={"15px"} variant={"16_black"} lineHeight={"30px"}>
                        Customisable Sales Price Threshold
                     </Text>
                  </Flex>

                  <Divider mt={"15px"} />
                  <Flex mt={"14px"}>
                     <Image
                        userSelect="none"
                        w={"14px"}
                        h={"30px"}
                        src={process.env.REACT_APP_PUBLIC_URL + "iconfont/icon_check_selected.svg"}
                     />
                     <Text ml={"15px"} variant={"16_black"} lineHeight={"30px"}>
                        Customisable Twitter Massages
                     </Text>
                  </Flex>
                  <Flex lineHeight={"26px"} mt={"2px"} alignItems={"center"} ml={"30px"}>
                     <Box bg="#999" borderRadius={"full"} w={"4px"} h={"4px"} />
                     <Text variant="16_gray" ml={"12px"}>
                        Prefix, Surfix, Twitter tags, Emoji, etc
                     </Text>
                  </Flex>

                  <Divider mt={"15px"} />
                  <Flex mt={"14px"}>
                     <Image
                        userSelect="none"
                        w={"14px"}
                        h={"30px"}
                        src={process.env.REACT_APP_PUBLIC_URL + "iconfont/icon_check_selected.svg"}
                     />
                     <Text ml={"15px"} variant={"16_black"} lineHeight={"30px"}>
                        Customisable Display Mode
                     </Text>
                  </Flex>
                  <Flex lineHeight={"26px"} mt={"2px"} alignItems={"center"} ml={"30px"}>
                     <Box bg="#999" borderRadius={"full"} w={"4px"} h={"4px"} />
                     <Text variant="16_gray" ml={"12px"}>
                        Full NFT Image
                     </Text>
                  </Flex>
                  <Flex lineHeight={"26px"} alignItems={"center"} ml={"30px"}>
                     <Box bg="#999" borderRadius={"full"} w={"4px"} h={"4px"} />
                     <Text variant="16_gray" ml={"12px"}>
                        Image format conversion
                     </Text>
                  </Flex>
                  <Flex lineHeight={"26px"} alignItems={"center"} ml={"30px"}>
                     <Box bg="#999" borderRadius={"full"} w={"4px"} h={"4px"} />
                     <Text variant="16_gray" ml={"12px"}>
                        Direct links to transactions
                     </Text>
                  </Flex>

                  <Divider mt={"15px"} />
                  <Flex mt={"14px"}>
                     <Image
                        userSelect="none"
                        w={"14px"}
                        h={"30px"}
                        src={process.env.REACT_APP_PUBLIC_URL + "iconfont/icon_check_selected.svg"}
                     />
                     <Text ml={"15px"} variant={"16_black"} lineHeight={"30px"}>
                        Customisable Sales Data Combination{" "}
                     </Text>
                  </Flex>
                  <Flex lineHeight={"26px"} mt={"2px"} alignItems={"center"} ml={"30px"}>
                     <Box bg="#999" borderRadius={"full"} w={"4px"} h={"4px"} />
                     <Text variant="16_gray" ml={"12px"}>
                        Data combination from multiple collections
                     </Text>
                  </Flex>

                  <Button
                     bg={"white"}
                     mt={"50px"}
                     fontSize={16}
                     colorScheme={"green"}
                     variant={"outline"}
                     borderRadius={"30px"}
                     onClick={(e) => {
                        if (!bLogin) {
                           navigate("/getstart");
                        } else {
                           navigate(`/${twitter_screen_name}/mybot`);
                        }
                     }}
                     height={"60px"}>
                     Get Started
                  </Button>
                  {/* <Button
                     bg={"white"}
                     mt={"50px"}
                     fontSize={16}
                     colorScheme={"black"}
                     border="1px solid"
                     borderColor={'green.500'}
                     color={"green.500"}
                     _hover={{backgroundColor:'green.500',color:'white',borderWidth:'0px'}}
                     borderRadius={"30px"}
                     onClick={(e) => {
                        if (!isLogin) {
                           navigate("/getstart");
                        } else {
                           navigate(`/${twitter_screen_name}/mybot`);
                        }
                     }}
                     height={"60px"}>
                     Get Started
                  </Button> */}
               </Flex>
            </Flex>

            <Flex
               as={motion.div}
               whileHover={{ y: "-10px" }}
               mr={"20px"}
               flex={1}
               flexDir={"column"}
               bg={"white"}
               boxShadow={"0px 20px 60px 0px rgba(0,0,0,0.04)"}
               borderRadius={"12px"}>
               <Flex bg={"green.500"} borderTopRadius={"12px"} flexDir={"column"} h={"166px"} alignItems={"center"}>
                  <Text variant={"26_white_bold"} mt={"30px"}>
                     Pro Version
                  </Text>
                  <Text variant={"16_white"} lineHeight={"22px"} mt={"12px"}>
                     More power to grow and engage
                  </Text>
                  <Text variant={"16_white"} lineHeight={"22px"}>
                     community for NFT projects
                  </Text>
               </Flex>
               <Flex px={"24px"} pt={"30px"} pb={"60px"} flex={1} flexDir={"column"}>
                  <Flex>
                     <Image
                        userSelect="none"
                        w={"14px"}
                        h={"30px"}
                        src={process.env.REACT_APP_PUBLIC_URL + "iconfont/icon_check_selected.svg"}
                     />
                     <Text ml={"15px"} variant={"16_black"} lineHeight={"30px"}>
                        Sales Posted on Twitter: Unlimited
                     </Text>
                  </Flex>

                  <Divider mt={"15px"} />
                  <Flex mt={"14px"}>
                     <Image
                        userSelect="none"
                        w={"14px"}
                        h={"30px"}
                        src={process.env.REACT_APP_PUBLIC_URL + "iconfont/icon_check_selected.svg"}
                     />
                     <Text ml={"15px"} variant={"16_black"} lineHeight={"30px"}>
                        Check for Sales: 30 seconds
                     </Text>
                  </Flex>

                  <Divider mt={"15px"} />
                  <Flex mt={"14px"}>
                     <Image
                        userSelect="none"
                        w={"14px"}
                        h={"30px"}
                        src={process.env.REACT_APP_PUBLIC_URL + "iconfont/icon_check_selected.svg"}
                     />
                     <Text ml={"15px"} variant={"16_black"} lineHeight={"30px"}>
                        Price Data in Multiple Tokens:
                     </Text>
                  </Flex>
                  <Flex lineHeight={"26px"} mt={"2px"} alignItems={"center"} ml={"30px"}>
                     <Box bg="#999" borderRadius={"full"} w={"4px"} h={"4px"} />
                     <Text variant="16_gray" ml={"12px"}>
                        ETH
                     </Text>
                  </Flex>
                  <Flex lineHeight={"26px"} alignItems={"center"} ml={"30px"}>
                     <Box bg="#999" borderRadius={"full"} w={"4px"} h={"4px"} />
                     <Text variant="16_gray" ml={"12px"}>
                        WETH
                     </Text>
                  </Flex>
                  <Flex lineHeight={"26px"} alignItems={"center"} ml={"30px"}>
                     <Box bg="#999" borderRadius={"full"} w={"4px"} h={"4px"} />
                     <Text variant="16_gray" ml={"12px"}>
                        USDC
                     </Text>
                  </Flex>
                  <Flex lineHeight={"26px"} alignItems={"center"} ml={"30px"}>
                     <Box bg="#999" borderRadius={"full"} w={"4px"} h={"4px"} />
                     <Text variant="16_gray" ml={"12px"}>
                        APE
                     </Text>
                  </Flex>
                  <Flex lineHeight={"26px"} alignItems={"center"} ml={"30px"}>
                     <Box bg="white" borderRadius={"full"} w={"4px"} h={"4px"} />
                     <Text variant="16_gray" ml={"12px"}>
                        ...
                     </Text>
                  </Flex>

                  <Divider mt={"15px"} />
                  <Flex mt={"14px"}>
                     <Image
                        userSelect="none"
                        w={"14px"}
                        h={"30px"}
                        src={process.env.REACT_APP_PUBLIC_URL + "iconfont/icon_check_selected.svg"}
                     />
                     <Text ml={"15px"} variant={"16_black"} lineHeight={"30px"}>
                        Most Comprehensive Data Sources:
                     </Text>
                  </Flex>
                  <Flex lineHeight={"26px"} mt={"2px"} alignItems={"center"} ml={"30px"}>
                     <Box bg="#999" borderRadius={"full"} w={"4px"} h={"4px"} />
                     <Text variant="16_gray" ml={"12px"}>
                        Opensea
                     </Text>
                  </Flex>
                  <Flex lineHeight={"26px"} alignItems={"center"} ml={"30px"}>
                     <Box bg="#999" borderRadius={"full"} w={"4px"} h={"4px"} />
                     <Text variant="16_gray" ml={"12px"}>
                        Looksrare
                     </Text>
                  </Flex>
                  <Flex lineHeight={"26px"} alignItems={"center"} ml={"30px"}>
                     <Box bg="#999" borderRadius={"full"} w={"4px"} h={"4px"} />
                     <Text variant="16_gray" ml={"12px"}>
                        X2Y2
                     </Text>
                  </Flex>
                  <Flex lineHeight={"26px"} alignItems={"center"} ml={"30px"}>
                     <Box bg="#999" borderRadius={"full"} w={"4px"} h={"4px"} />
                     <Text variant="16_gray" ml={"12px"}>
                        Gem
                     </Text>
                  </Flex>
                  <Flex lineHeight={"26px"} alignItems={"center"} ml={"30px"}>
                     <Box bg="#999" borderRadius={"full"} w={"4px"} h={"4px"} />
                     <Text variant="16_gray" ml={"12px"}>
                        Genie
                     </Text>
                  </Flex>

                  <Divider mt={"15px"} />
                  <Flex mt={"14px"}>
                     <Image
                        userSelect="none"
                        w={"14px"}
                        h={"30px"}
                        src={process.env.REACT_APP_PUBLIC_URL + "iconfont/icon_check_selected.svg"}
                     />
                     <Text ml={"15px"} variant={"16_black"} lineHeight={"30px"}>
                        Customisable Sales Price Threshold
                     </Text>
                  </Flex>

                  <Divider mt={"15px"} />
                  <Flex mt={"14px"}>
                     <Image
                        userSelect="none"
                        w={"14px"}
                        h={"30px"}
                        src={process.env.REACT_APP_PUBLIC_URL + "iconfont/icon_check_selected.svg"}
                     />
                     <Text ml={"15px"} variant={"16_black"} lineHeight={"30px"}>
                        Customisable Twitter Massages
                     </Text>
                  </Flex>
                  <Flex lineHeight={"26px"} mt={"2px"} alignItems={"center"} ml={"30px"}>
                     <Box bg="#999" borderRadius={"full"} w={"4px"} h={"4px"} />
                     <Text variant="16_gray" ml={"12px"}>
                        Prefix, Surfix, Twitter tags, Emoji, etc
                     </Text>
                  </Flex>

                  <Divider mt={"15px"} />
                  <Flex mt={"14px"}>
                     <Image
                        userSelect="none"
                        w={"14px"}
                        h={"30px"}
                        src={process.env.REACT_APP_PUBLIC_URL + "iconfont/icon_check_selected.svg"}
                     />
                     <Text ml={"15px"} variant={"16_black"} lineHeight={"30px"}>
                        Customisable Display Mode
                     </Text>
                  </Flex>
                  <Flex lineHeight={"26px"} mt={"2px"} alignItems={"center"} ml={"30px"}>
                     <Box bg="#999" borderRadius={"full"} w={"4px"} h={"4px"} />
                     <Text variant="16_gray" ml={"12px"}>
                        Full NFT Image
                     </Text>
                  </Flex>
                  <Flex lineHeight={"26px"} alignItems={"center"} ml={"30px"}>
                     <Box bg="#999" borderRadius={"full"} w={"4px"} h={"4px"} />
                     <Text variant="16_gray" ml={"12px"}>
                        Image format conversion
                     </Text>
                  </Flex>
                  <Flex lineHeight={"26px"} alignItems={"center"} ml={"30px"}>
                     <Box bg="#999" borderRadius={"full"} w={"4px"} h={"4px"} />
                     <Text variant="16_gray" ml={"12px"}>
                        Direct links to transactions
                     </Text>
                  </Flex>

                  <Divider mt={"15px"} />
                  <Flex mt={"14px"}>
                     <Image
                        userSelect="none"
                        w={"14px"}
                        h={"30px"}
                        src={process.env.REACT_APP_PUBLIC_URL + "iconfont/icon_check_selected.svg"}
                     />
                     <Text ml={"15px"} variant={"16_black"} lineHeight={"30px"}>
                        Customisable Sales Data Combination
                     </Text>
                  </Flex>

                  <Flex lineHeight={"26px"} mt={"2px"} alignItems={"center"} ml={"30px"}>
                     <Box bg="#999" borderRadius={"full"} w={"4px"} h={"4px"} />
                     <Text variant="16_gray" ml={"12px"}>
                        Data combination from multiple collections
                     </Text>
                  </Flex>

                  <Spacer />
                  <Button
                     mt={"50px"}
                     fontSize={16}
                     color={"white"}
                     boxShadow={"0px 16px 30px 0px rgba(201,239,226,1)"}
                     colorScheme={"green"}
                     borderRadius={"30px"}
                     onClick={(e) => {
                        if (!bLogin) {
                           navigate("/getstart");
                        } else {
                           navigate(`/${twitter_screen_name}/pay`);
                        }
                     }}
                     height={"60px"}>
                     Get Started
                  </Button>
               </Flex>
            </Flex>
            <Flex
               as={motion.div}
               whileHover={{ y: "-10px" }}
               flex={1}
               flexDir={"column"}
               bg={"white"}
               boxShadow={"0px 20px 60px 0px rgba(0,0,0,0.04)"}
               borderRadius={"12px"}>
               <Flex bg={"black"} borderTopRadius={"12px"} flexDir={"column"} h={"166px"} alignItems={"center"}>
                  <Text variant={"26_white_bold"} mt={"30px"}>
                     Customised Version
                  </Text>
                  <Text lineHeight={"22px"} variant={"16_white"} alignItems={"center"} mt={"12px"}>
                     All flexibility to meet your requirements
                  </Text>
                  <Text lineHeight={"22px"} variant={"16_white"} alignItems={"center"}>
                     and all the power to match the
                  </Text>
                  <Text lineHeight={"22px"} variant={"16_white"} alignItems={"center"}>
                     community growth
                  </Text>
               </Flex>
               <Flex px={"24px"} pt={"30px"} pb={"60px"} flex={1} flexDir={"column"}>
                  <Text fontFamily={'Arial-BoldMT'} fontSize={18}>
                     All the goodness of Pro Version, and:
                  </Text>
                  <Flex mt={"30px"}>
                     <Image
                        userSelect="none"
                        w={"14px"}
                        h={"30px"}
                        src={process.env.REACT_APP_PUBLIC_URL + "iconfont/icon_check_selected.svg"}
                     />
                     <Text ml={"15px"} variant={"16_black"} lineHeight={"30px"}>
                        Customisable display of exclusively designed NFT image
                     </Text>
                  </Flex>
                  <Divider mt={"15px"} />
                  <Flex mt={"14px"}>
                     <Image
                        userSelect="none"
                        w={"14px"}
                        h={"30px"}
                        src={process.env.REACT_APP_PUBLIC_URL + "iconfont/icon_check_selected.svg"}
                     />
                     <Text ml={"15px"} variant={"16_black"} lineHeight={"30px"}>
                        Sales data from any other marketplaces
                     </Text>
                  </Flex>
                  <Divider mt={"15px"} />
                  <Flex mt={"14px"}>
                     <Image
                        userSelect="none"
                        w={"14px"}
                        h={"30px"}
                        src={process.env.REACT_APP_PUBLIC_URL + "iconfont/icon_check_selected.svg"}
                     />
                     <Text ml={"15px"} variant={"16_black"} lineHeight={"30px"}>
                        Sales data from any other smart contracts
                     </Text>
                  </Flex>
                  <Divider mt={"15px"} />
                  <Flex mt={"14px"}>
                     <Image
                        userSelect="none"
                        w={"14px"}
                        h={"30px"}
                        src={process.env.REACT_APP_PUBLIC_URL + "iconfont/icon_check_selected.svg"}
                     />
                     <Text ml={"15px"} variant={"16_black"} lineHeight={"30px"}>
                        Sales data of NFT with specific attributes from a collection
                     </Text>
                  </Flex>
                  <Spacer />

                  <Button
                     w="full"
                     bg={"black"}
                     mt={"50px"}
                     fontSize={16}
                     onClick={(e) => window.open("https://twitter.com/Aloha_Bots")}
                     colorScheme={"black"}
                     _hover={{ color: "aloha_blue" }}
                     color={"white"}
                     borderRadius={"30px"}
                     rightIcon={<FaTwitter />}
                     height={"60px"}>
                     DM
                  </Button>
               </Flex>
            </Flex>
         </Flex>
      </Flex>
   );
}
export default memo(PricingComponent);
